module.exports = __webpack_public_path__ + "DejaVuSansMono-Bold.fb4ec87d51ddbe7c5d2f.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/external_css/kendo-ui/fonts/DejaVu/DejaVuSansMono-Bold.ttf?v=1.1
// module id = ../../../../../external_css/kendo-ui/fonts/DejaVu/DejaVuSansMono-Bold.ttf?v=1.1
// module chunks = styles